import React from "react";
import {Link} from "react-router";

export default class ObjectInfo extends React.Component {
    render() {
        const url = `/${this.props.params.widget}/map/${this.props.params.id}`;

        const object = this.props.data.objects.find(obj => {
            return obj.number === this.props.params.number;
        });

        return (
            <div>
                <div className="cw-main-header">
                    <div className="container">
                        <Link className="float-right" to={`//webservices.carbonwhite.se/_data/${object.pdf_url}`} target="_new">Bofaktablad</Link>
                        <Link to={url}>Tillbaka</Link>
                    </div>
                </div>

                <div className="cw-object-info-main">
                    <div className="container">
                        <div className="cw-object-info-wrapper">
                        <div className="cw-object-info-data">
                            <div className="cw-object-info-heading">Lgh {object.number}</div>
                            <table className="cw-object-info-table">
                                <tbody>
                                <tr>
                                    <th>Våning:</th>
                                    <td>{object.floor_number}</td>
                                </tr>
                                <tr>
                                    <th>Rum:</th>
                                    <td>{object.rooms} rok</td>
                                </tr>
                                <tr>
                                    <th>Boarea:</th>
                                    <td>{object.living_area} m<sup>2</sup></td>
                                </tr>
                                {object.usp1 &&
                                <tr>
                                    <th>Inredningsval:</th>
                                    <td>{object.usp1}</td>
                                </tr>
                                    }
                                {object.status_id !== 6 &&
                                <tr>
                                    <th>Pris:</th>
                                    <td>{object.price_format} kr</td>
                                </tr>
                                }
                                {object.status_id !== 6 &&
                                <tr>
                                    <th>Avgift:</th>
                                    <td>{object.monthly_fee_format} kr</td>
                                </tr>
                                }
                                <tr>
                                    <th>Status:</th>
                                    <td><span
                                        className={'status-blob status-blob-' + object.status_id}></span> {object.status_name}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="cw-object-info-plan">
                            <img src={`//webservices.carbonwhite.se/_data/${object.plan_url}`} alt="Planritning"/>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ObjectInfo.jsx